import AppLayout from '../Layout/AppLayout';
import ContenuPub from '../Components/Pub/ContenuPub';

const Pub = () => {
    return (
        <AppLayout>
            <ContenuPub />
        </AppLayout>
    );
};

export default Pub;
